/* eslint-disable */
export default {
  unmute: 'Stummschaltung aufheben',
  mute: 'Stummschalten',
  keypad: 'Wähltastatur',
  hold: 'Halten',
  onHold: 'Wird gehalten',
  park: 'Parken',
  stopRecord: 'Stoppen',
  record: 'Aufnehmen',
  add: 'Hinzufügen',
  transfer: 'Weiterleiten',
  flip: 'Umlegen',
  more: 'Anrufaktionen',
  mergeToConference: 'Zusammenführen',
  end: 'Beenden',
  completeTransfer: 'Übergabe\nabschließen',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
